import * as Cookies from "js-cookie";
window.Cookies = Cookies;

export default class {

    constructor() {
        this.container = document.querySelector('#cookie-popup');

        // Is the element present on the current page
        if (! this.container) {
            return;
        }

        this.cookieName = 'accept-cookies'
        this.closeButton = this.container.querySelector('.cookie__close');

        // if we dont have the cookie, show it
        if (! Cookies.get(this.cookieName)) {
            this.container.classList.add('show');
        } else {
            // we have the cookie
            return;
        }

        // on close store the cookie and hide it
        this.closeButton.addEventListener('click', () => {
            Cookies.set(this.cookieName, 'true', { expires: 365/2 });

            if (this.container.classList.contains('show')) {
                this.container.classList.remove('show');
            }
        });
    }
}